"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
// eslint-disable-next-line import/prefer-default-export
exports.saveFeatureFlag = function (name, value) {
    return toolkit_1.createAction(constants_1.SAVE_FEATURE_FLAG)({ name: name, value: value });
};
exports.saveAllFeatureFlags = function (featureFlags) {
    return toolkit_1.createAction(constants_1.SAVE_ALL_FEATURE_FLAGS)(featureFlags);
};
//# sourceMappingURL=actions.js.map